"use strict";

 angular.module('app.env', [])

.constant('envDeployment', {deploymentUUID:'6cf60ba7-e8b5-4875-a57c-b995db808974'})

;